import { render, staticRenderFns } from "./OECDGuidelinesList.vue?vue&type=template&id=ed8393ac&"
import script from "./OECDGuidelinesList.vue?vue&type=script&lang=js&"
export * from "./OECDGuidelinesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports